import httpClient from './httpClient';

export const ACCORDION_SET_ENDPOINT = '/backoffice/product-accordion-sets';

export const getAccordionSetsAPI = async (params) => httpClient.get(`${ACCORDION_SET_ENDPOINT}`, { params });
export const getAccordionSetAPI = async (accordionSetId) => httpClient.get(`${ACCORDION_SET_ENDPOINT}/${accordionSetId}`);
export const createAccordionSetAPI = async (params) => httpClient.post(`${ACCORDION_SET_ENDPOINT}`, params);
export const putAccordionSetAPI = async (accordionSetId, params) => httpClient.put(`${ACCORDION_SET_ENDPOINT}/${accordionSetId}`, params);
export const deleteAccordionSetAPI = async (accordionSetId) => httpClient.delete(`${ACCORDION_SET_ENDPOINT}/${accordionSetId}`);
